export default {
  DIALCAST_RECIPIENT_GROUP_LIST (state, value) {
    state.list = (value && Array.isArray(value)) ? value : []
  },
  DIALCAST_RECIPIENT_GROUP_LIST_UPDATE (state, value) {
    const index = state.list.findIndex((i) => i.id === value.id)
    if (index !== -1) {
      state.list.splice(index, 1, Object.assign(state.list[index], value))
    } else {
      state.list.push(value) // reason: see fetchModel.js
    }
  },
  DIALCAST_RECIPIENT_GROUP_LIST_REMOVE (state, value) {
    const index = state.list.findIndex((i) => i.id === value)
    if (index !== -1) {
      state.list.splice(index, 1)
    }
  }
}
